import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { useMediaQuery } from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

// Assets
import backgroundImage from "assets/images/bg-all-events.png";
import CalendarCheckIcon from "assets/images/icons/Calendar_Check.png";
import CoinIcon from "assets/images/icons/Coin.png";
import HourglassIcon from "assets/images/icons/Hourglass.png";
import ProjectRecordingIcon from "assets/images/icons/ProjectRecording.png";
import UserIcon from "assets/images/icons/UserCircle.png";

//User Data
import { UserContext } from "context";

// Data
import tableDataDeadlines from "layouts/dashboard/components/Projects/data/deadlines";

// ENV Values
const apiUrl = process.env.REACT_APP_API_URL;

function MyDeadlines() {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();
  const [userData, setUserData] = useState([]);
  const { columns: aColumns, rows: aRows } = tableDataDeadlines({ mode: 0 });
  const { columns: dColumns, rows: dRows } = tableDataDeadlines({ mode: 1 });
  const { columns: pColumns, rows: pRows } = tableDataDeadlines({ mode: 2 });
  const { columns: adminNewColumns, rows: adminNewRows } = tableDataDeadlines({
    mode: 0,
    admin: user.isAdmin,
  });
  const { columns: adminWaitColumns, rows: adminWaitRows } = tableDataDeadlines({
    mode: 1,
    admin: user.isAdmin,
  });
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(`${apiUrl}/profile.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ user_id: user.id }),
        });
        const userData = await response.json();
        setUserData(userData);
      } catch (error) {
        console.error("Failed to fetch user data", error);
      }
    };
    if (user?.id) {
      fetchUserData();
    }
  }, [user]);

  // Detect if the screen is mobile-sized
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        display="flex"
        alignItems="center"
        justifyContent="center"
        position="relative"
        borderRadius="xl"
        sx={{
          minHeight: { xs: "8.75rem", sm: "18.75rem" },
          backgroundImage: ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
            `url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "50%",
          overflow: "hidden",
        }}
      >
        {!user.isAdmin && (
          <MDBox position="absolute" top="16px" left="16px">
            <MDButton
              display="flex"
              justifyContent={isMobile ? "center" : "space-between"} // Center icon on mobile
              color="secondary"
              mt={0.2}
              alignItems="center"
              onClick={() => navigate("/app/profile")}
            >
              <MDBox
                component="img"
                src={UserIcon}
                alt="NewRequest"
                width="24px"
                ml={-1}
                mr={isMobile ? -1 : 1}
                my={-4}
                sx={{
                  cursor: "pointer",
                }}
              />
              {!isMobile && (
                <MDTypography
                  variant="h7"
                  fontWeight="medium"
                  textTransform="white"
                  color="white"
                  mt={0.2}
                  sx={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {userData.name} {userData.surname}
                </MDTypography>
              )}
            </MDButton>
          </MDBox>
        )}
        <MDTypography
          variant="h1"
          color="white"
          sx={{
            my: 2,
            px: { xs: 6 },
            textAlign: "center",
          }}
        >
          {user.isAdmin ? "Scadenziario Staff" : "Le tue Scadenze"}
        </MDTypography>
      </MDBox>
      <MDBox
        sx={{
          mt: { xs: 4, sm: -12 },
          mx: { xs: 0, sm: 3 },
          pt: 2,
          px: { xs: 0, sm: 2 },
        }}
      >
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-2}
                py={2}
                px={2}
                variant="gradient"
                sx={{
                  backgroundColor: "#000000",
                }}
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                alignItems="center"
              >
                <MDTypography variant="h4" color="white" sx={{ mr: 1 }}>
                  Scadenze {user.isAdmin ? "Permessi" : ""}
                </MDTypography>
                <MDBox
                  component="img"
                  src={CalendarCheckIcon}
                  alt="NewRequest"
                  width="24px"
                  my={-4}
                  sx={{
                    cursor: "pointer",
                  }}
                />
              </MDBox>
              <MDTypography mx={4} mt={1} component="p" variant="button" color="text">
                Clicca sulla freccia per andare al documento che richiede la tua attenzione
              </MDTypography>
              <MDBox pt={3}>
                <DataTable
                  table={{
                    columns: user.isAdmin ? aColumns : dColumns,
                    rows: user.isAdmin ? aRows : dRows,
                  }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
          {user.isAdmin ? (
            <>
              <Grid item xs={12}>
                <Card>
                  <MDBox
                    mx={2}
                    mt={-2}
                    py={2}
                    px={2}
                    variant="gradient"
                    sx={{
                      backgroundColor: "#438E80",
                    }}
                    borderRadius="lg"
                    coloredShadow="info"
                    display="flex"
                    alignItems="center"
                  >
                    <MDTypography variant="h4" color="white" sx={{ mr: 1 }}>
                      Nuove Richieste (ATTESA DI VALUTAZIONE)
                    </MDTypography>
                    <MDBox
                      component="img"
                      src={ProjectRecordingIcon}
                      alt="NewRequest"
                      width="24px"
                      my={-4}
                      sx={{
                        cursor: "pointer",
                      }}
                    />
                  </MDBox>
                  <MDTypography mx={4} mt={1} component="p" variant="button" color="text">
                    Le nuove richieste di permesso
                  </MDTypography>
                  <MDBox pt={3}>
                    <DataTable
                      table={{ columns: adminNewColumns, rows: adminNewRows }}
                      isSorted={true}
                      entriesPerPage={false}
                      showTotalEntries={false}
                      noEndBorder
                    />
                  </MDBox>
                </Card>
              </Grid>
              <Grid item xs={12}>
                <Card>
                  <MDBox
                    mx={2}
                    mt={-2}
                    py={2}
                    px={2}
                    variant="gradient"
                    sx={{
                      backgroundColor: "#3A496A",
                    }}
                    borderRadius="lg"
                    coloredShadow="info"
                    display="flex"
                    alignItems="center"
                  >
                    <MDTypography variant="h4" color="white" sx={{ mr: 1 }}>
                      In Attesa di Permesso (IN EMISSIONE)
                    </MDTypography>
                    <MDBox
                      component="img"
                      src={HourglassIcon}
                      alt="NewRequest"
                      width="24px"
                      my={-4}
                      sx={{
                        cursor: "pointer",
                      }}
                    />
                  </MDBox>
                  <MDTypography mx={4} mt={1} component="p" variant="button" color="text">
                    Gli eventi che sono in stato "in emissione"
                  </MDTypography>
                  <MDBox pt={3}>
                    <DataTable
                      table={{ columns: adminWaitColumns, rows: adminWaitRows }}
                      isSorted={true}
                      entriesPerPage={false}
                      showTotalEntries={false}
                      noEndBorder
                    />
                  </MDBox>
                </Card>
              </Grid>
            </>
          ) : (
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-2}
                  py={2}
                  px={2}
                  variant="gradient"
                  sx={{
                    backgroundColor: "#438E80",
                  }}
                  borderRadius="lg"
                  coloredShadow="info"
                  display="flex"
                  alignItems="center"
                >
                  <MDTypography variant="h4" color="white" sx={{ mr: 1 }}>
                    Pagamenti da effettuare {user.isAdmin ? "Permessi" : ""}
                  </MDTypography>
                  <MDBox
                    component="img"
                    src={CoinIcon}
                    alt="NewRequest"
                    width="24px"
                    my={-4}
                    sx={{
                      cursor: "pointer",
                    }}
                  />
                </MDBox>
                <MDTypography mx={4} mt={1} component="p" variant="button" color="text">
                  Le azioni che richiedono la tua attenzione
                </MDTypography>
                <MDBox pt={3}>
                  <DataTable
                    table={{ columns: pColumns, rows: pRows }}
                    isSorted={true}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                </MDBox>
              </Card>
            </Grid>
          )}
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default MyDeadlines;

